import { Button, Col, Divider, Form, Image, Input, Row, Select } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { EditOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";
import { editContent, getContentbyId, uploadImage } from "./ContentApi";
import { JsonEditor } from "json-edit-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { IoAddOutline, IoMenu } from "react-icons/io5";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
function UpdateContent() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const { Option } = Select;
  const [contentData, setContentData] = useState({});
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [metaContent, setMetaContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorInJson, setErrorInJson] = useState(false);

  const handleFileUpload = useCallback(
    async (e) => {
      try {
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        setContentData({ ...contentData, image: url });
      } catch (error) {
        console.log({ error });
      }
    },
    [contentData]
  );

  function FetchContentDataByID() {
    getContentbyId(`${fill._id}`)
      .then((response) => {
        if (response.success) {
          setContentData(response.data.content);
          form.setFieldsValue(response.data.content);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  console.log(contentData?.image);

  const setJSONData = () => {};

  useEffect(() => {
    FetchContentDataByID();
  }, [form]);

  const generateSlug = (value) => {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const handleTitleChange = (e) => {
    const inputValue = e.target.value;
    const slugValue = generateSlug(inputValue);

    const updatedMetaTags = form.getFieldValue("metaTags") || [];
    if (updatedMetaTags.length > 0) {
      updatedMetaTags[0].content = inputValue;
    } else {
      updatedMetaTags.push({ name: "title", content: inputValue });
    }

    form.setFieldsValue({
      slug: slugValue,
      metaTags: updatedMetaTags,
    });

    setTitle(inputValue);
    setSlug(slugValue);
    setMetaContent(inputValue);
  };

  const navigate = useNavigate();
  const updateContentData = () => {
    try {
      if (errorInJson) return;
      const values = form.getFieldsValue();
      console.log(values, "updated form values");

      const payload = {
        contentId: contentData?._id,
        title: values.title,
        slug: values.slug,
        pageKeyword: values.pageKeyword,
        rteString: values.rteString,
        image: contentData?.image,
        meta: values.meta,
        faqs: values.faqs,
        blogCategory: values.blogCategory,
        content: values.content,
        sitemap: contentData?.sitemap,
      };

      console.log({ payload, contentData });

      setIsLoading(true);

      editContent(payload)
        .then((response) => {
          if (response.success) {
            navigate("/content/contentData");
            form.resetFields();
            setIsLoading(false);
          } else {
            dispatchtoast("Fields can not be empty", true);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsLoading(false);
        });
    } catch (err) {
      console.error("Error updating content:", err);
    }
  };

  const metaTagOptions = ["description", "title", "keywords", "robots", "author"];

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    console.log(result);
    const content = form.getFieldValue("content") || [];
    const newContent = [...content];

    const [movedItem] = newContent.splice(result.source.index, 1);
    newContent.splice(result.destination.index, 0, movedItem);

    form.setFieldsValue({ content: newContent });
  };

  return (
    <div>
      <Divider orientation="left" style={{ border: "#cecece" }} className="text-base tracking-normal font-dmsans font-normal  text-gray-900">
        {from === "edit" ? "Update" : "Add"} Content Data
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={updateContentData}
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? contentData
            : {
                meta: [{ name: "Title", content: "" }],
                components: [{ heading: "", paragraph: [] }],
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Title</p>}
              name="title"
              rules={[
                { required: true, message: "Please enter Title" },
                { min: 4, message: "Title must be at least 4 characters" },
              ]}
            >
              <Input placeholder="e.g.,Empower Your Learning" value={title} onChange={handleTitleChange} />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Slug</p>}
              name="slug"
              rules={[
                { required: true, message: "Please enter Slug" },
                { min: 6, message: "Slug must be at least 6 characters" },
                {
                  pattern: /^[a-z0-9_-]+$/,
                  message: "Slug can only contain lowercase letters, numbers, and hyphens (no spaces, slashes, dots, or capitals)",
                },
              ]}
            >
              <Input placeholder="e.g.,Empower-Your-Learning" value={slug} disabled={contentData.sport === "Sports" || contentData.isSportPage} onChange={(e) => setSlug(e.target.value)} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Type</p>} name="type">
              <Select disabled placeholder="Live" suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}>
                {["Live", "Odds", "Prediction"].map((option) => (
                  <Select.Option key={option} value={option}>
                    {option}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Sport</p>} name="sport">
              <Select disabled placeholder="Live" suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}>
                {["American Football", "Baseball", "Basketball", "Boxing", "Cricket", "Football", "Ice Hockey", "MMA", "Motor Racing", "Rugby", "Sports", "Tennis"].map((option) => (
                  <Select.Option key={option} value={option}>
                    {option}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1 gap-4 mb-5 border rounded-md px-5 py-3">
          <Col>
            <small>Image</small>
            <p className="w-full text-balance" style={{ overflowWrap: "break-word" }}>
              {contentData.image}
            </p>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Page Keyword</p>} name="pageKeyword">
              <Input placeholder="e.g.,Your go-to source for course tips, updates, and success stories." />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Sport Page</p>} name="isSportPage" rules={[{ required: true, message: "Please select an option" }]}>
              <Select disabled placeholder="True" suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}>
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <JsonEditor
          data={contentData?.sitemap ? JSON.parse(contentData?.sitemap) : {}}
          setData={(v) => {
            console.log("json was set ");
            setContentData({ ...contentData, sitemap: JSON.stringify(v) });
            setErrorInJson(false);
          }}
          onError={(e) => setErrorInJson(true)}
        />
        <Row className="grid grid-cols-1 gap-4">
          <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Meta Tags</p>
          <Col>
            <Form.Item validateTrigger="onSubmit" style={{ marginBottom: "16px" }}>
              <Form.List
                name="meta"
                rules={[
                  {
                    validator: async (_, metaTags) => {
                      if (!metaTags || metaTags.length < 1) {
                        return Promise.reject(new Error("Please add at least one tag"));
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey, ...restField }, index) => {
                      const availableTags = metaTagOptions;

                      return (
                        <div key={key} style={{ marginBottom: "16px" }} className="grid grid-cols-1 sm:grid-cols-[1%_47%_40%_8%] gap-4">
                          <p className="font-medium">{index + 1}.</p>

                          <Form.Item
                            {...restField}
                            name={[name, "name"]}
                            fieldKey={[fieldKey, "name"]}
                            rules={[
                              {
                                required: true,
                                message: "Please select a meta tag name",
                              },
                            ]}
                          >
                            <Select placeholder="Select a tag" suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}>
                              {availableTags.slice(0, 5).map((option) => (
                                <Option key={option} value={option}>
                                  {option.charAt(0).toUpperCase() + option.slice(1)}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "content"]}
                            fieldKey={[fieldKey, "content"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter meta tag content",
                              },
                            ]}
                          >
                            <Input.TextArea placeholder="e.g.,Discover New Courses and Ideas" />
                          </Form.Item>

                          <Button onClick={() => remove(name)} className="remove-button NoButtonHover ">
                            Remove
                          </Button>
                        </div>
                      );
                    })}

                    <Form.Item>
                      <Button className="bg-[#4d3300] text-xs text-white w-1/2 rounded-[5px] customButtonHover" onClick={() => add()} block icon={<PlusOutlined />}>
                        Add Meta Tag
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1 gap-4">
          <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">FAQs</p>
          <Col>
            <Form.Item validateTrigger="onSubmit" style={{ marginBottom: "16px" }}>
              <Form.List name="faqs">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey, ...restField }, index) => {
                      return (
                        <div key={key} style={{ marginBottom: "16px" }} className="grid grid-cols-1 sm:grid-cols-[1%_47%_40%_8%] gap-4">
                          <p className="font-medium">{index + 1}.</p>

                          <Form.Item
                            {...restField}
                            name={[name, "q"]}
                            fieldKey={[fieldKey, "q"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter a question",
                              },
                            ]}
                          >
                            <Input.TextArea placeholder="e.g.,Frequently asked question" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "a"]}
                            fieldKey={[fieldKey, "a"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter answer",
                              },
                            ]}
                          >
                            <Input.TextArea placeholder="e.g.,Discover New Courses and Ideas" />
                          </Form.Item>

                          <Button onClick={() => remove(name)} className="remove-button NoButtonHover ">
                            Remove
                          </Button>
                        </div>
                      );
                    })}

                    <Form.Item>
                      <Button className="bg-[#4d3300] text-xs text-white w-1/2 rounded-[5px] customButtonHover" onClick={() => add()} block icon={<PlusOutlined />}>
                        Add FAQ
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1 gap-4 mb-16">
          <Form.Item label="Content" name="rteString">
            <ReactQuill form={form} name="rteString" />
          </Form.Item>
        </Row>

        {/* 
        <Row className="grid grid-cols-1 gap-4">
          <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Content</p>
          <Col>
            <Form.List
              name="content"
              initialValue={[{ heading: "", paragraph: [""] }]}
              rules={[
                {
                  validator: async (_, content) => {
                    if (!content || content.length < 1) {
                      return Promise.reject(new Error("Please add at least one content item."));
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }) => (
                <>
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Draggable key={key} draggableId={String(key)} index={index}>
                              {(provided) => (
                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                  <div className=" bg-white grid grid-cols-[5%_5%_80%_9%] gap-2 mb-2">
                                    <span>
                                      <IoMenu />
                                    </span>
                                    <span>{index + 1}.</span>
                                    <Form.Item
                                      {...restField}
                                      label="Heading"
                                      name={[name, "heading"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please input heading",
                                        },
                                      ]}
                                    >
                                      <Input placeholder="Heading" />
                                    </Form.Item>
                                    <Button danger onClick={() => remove(name)}>
                                      Remove
                                    </Button>
                                  </div>
                                  <Form.List name={[name, "paragraph"]}>
                                    {(paraFields, { add: addPara, remove: removePara }) => (
                                      <>
                                        {paraFields.map((field) => (
                                          <div key={field.key} className="grid grid-cols-[5%_5%_80%_9%] gap-2 mb-2">
                                            <span></span>
                                            <span></span>
                                            <Form.Item
                                              {...field}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Enter paragraph",
                                                },
                                              ]}
                                              className="w-full"
                                            >
                                              <Input.TextArea placeholder="Paragraph" />
                                            </Form.Item>
                                            <Button danger onClick={() => removePara(field.name)} className="p-0 font-extrabold border-none">
                                              <MinusCircleOutlined />
                                            </Button>
                                          </div>
                                        ))}
                                        <Form.Item>
                                          <Button type="dashed" onClick={() => addPara()} block icon={<PlusOutlined />} className="text-xs">
                                            Add Paragraph
                                          </Button>
                                        </Form.Item>
                                      </>
                                    )}
                                  </Form.List>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>

                  <Form.Item>
                    <Button className="bg-[#4d3300] text-xs text-white w-1/2 rounded-[5px] customButtonHover" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Content
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
 */}

        {contentData.image ? (
          <Row className="grid grid-cols-1  gap-4">
            <Col>
              <Form.Item name="image" label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Content image</p>}>
                <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                  <Image
                    src={contentData.image}
                    height={127}
                    style={{
                      objectFit: "cover",
                      borderRadius: "11px",
                    }}
                    preview={false}
                  />

                  <input type="file" name="photo" id="upload-photo" onChange={handleFileUpload} />
                  <label for="upload-photo" className="cursor-pointer">
                    <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                  </label>
                  {/* <button >Replace</button> */}
                </div>
              </Form.Item>
            </Col>
          </Row>
        ) : (
          <>
            <Form.Item name="image" label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Add Content image</p>}>
              <input type="file" name="photo" id="upload-photo" onChange={handleFileUpload} />
              <label for="upload-photo" className="cursor-pointer">
                <IoAddOutline className=" text-xs bg-red-600   rounded-full text-white w-[26px] h-[26px] flex justify-center text-center  bottom-0 opacity-80" />
              </label>
            </Form.Item>{" "}
          </>
        )}

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                from === "edit" ? navigate("/blog/blogData") : form.resetFields();
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
              htmlType="onSubmit"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            <Button className="NoButtonHover create-button" size="small" htmlType="submit" loading={isLoading}>
              {from === "edit" ? "Edit" : "Create"} Content
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default UpdateContent;
